// extracted by mini-css-extract-plugin
export default {"form":"Register_form__XOYYJ","title":"Register_title__+axnN"};